import { render, staticRenderFns } from "./RouteMultiselect.vue?vue&type=template&id=19dd1021"
import script from "./RouteMultiselect.vue?vue&type=script&lang=js"
export * from "./RouteMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports